import { Component, OnInit } from '@angular/core';
import { BrandingMessages, Servicesoffered, ThemeConfig } from '../../../appconfig';
import { User } from '../../auth/login/login.model';
import { Router } from '@angular/router';
import { CommonService, RestService } from '../../services/common';
import { JwtService } from '../../auth/jwtservice';
import { ThemeService } from '../../services/common/theme.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthSessionService } from '../auth-session.service';

@Component({
  selector: 'app-aggregator',
  templateUrl: './aggregator.component.html',
  styleUrl: './aggregator.component.scss'
})
export class AggregatorComponent implements OnInit {
  loginUserData: User = { email: '', password: '' };
  errorMessage: string = '';
  show_button: Boolean = false;
  show_eye: Boolean = false;
  requiredRoles: any;
  userRoles: any;
  currentHostA2G: any;
  copyrightMessage: string = BrandingMessages.copyrightMessage;
  servicesOffering: string[] = Servicesoffered.AggregatorServices;
  backgroundClass: string = 'back-img-aggregator'; // default class

  defaultTheme: ThemeConfig = {
    primaryBackgroundColor: '#BA141A',
    secondaryBackgroundColor: '#ffffff',
    primaryFontColor: '#000000',
    secondaryFontColor: '#ffffff',
    logoUrl: '',
    organizationName: window.location.origin.toLowerCase().indexOf('a2g') > -1 ? 'DocuMap' : 'ERP'
  };

  constructor(
    private router: Router,
    private restService: RestService,
    private commonService: CommonService,
    private jwtService: JwtService,
    private themeService: ThemeService,
    private authSessionService: AuthSessionService
  ) {
    //just after logout or session expired login component will render and initially
    // local storage will be clear here before initializing login component
    localStorage.clear();
  }

  ngOnInit() {
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('aggregator')) {
      this.backgroundClass = 'back-img-aggregator';
    } else if (currentUrl.includes('developer')) {
      this.backgroundClass = 'back-img-developer';
    }

    if (window.location.origin.toLowerCase().indexOf('a2g') > -1) {
      this.currentHostA2G = true;
    };
  }

  //Function
  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

  /**
   * Authenticates the user, stores the JWT token, then:
   * 1. Immediately updates roles from the token and navigates to the first accessible route.
   * 2. In parallel (non-blocking), fires AuthSessionService.initializeUserSession() which:
   *    - Applies org theme immediately (org details from login response — no extra API call)
   *    - Fetches sites, projects, explorations via forkJoin
   */
  Submit() {
    this.restService.postData('Login', this.loginUserData).subscribe(data => {

      // --- Step 1: Store token and essential identity info ---
      this.commonService.setLocalStorageValue('mbcrm/token', data?.result?.token);
      this.commonService.setLocalStorageValue('userId', data?.result?.userDetail?.id);
      this.commonService.setLocalStorageValue('CRM', 'true');

      // Cache lightweight user details
      this.authSessionService.cacheUserDetails(data);

      // --- Step 2: Refresh roles from the new token immediately ---
      // (roles are embedded in the JWT, no extra API call needed)
      this.jwtService.updateUserRolesFromToken();
      this.userRoles = this.jwtService.currentUserRolesValue;

      // --- Step 3: Kick off background session init (non-blocking) ---
      // org details & userGroup come from login response (lightweight — single record each)
      // sites, projects, explorations are fetched in parallel via forkJoin inside the service
      const orgDetails = data?.result?.userDetail?.organizationDetails;
      const userGroup = data?.result?.userDetail?.userGroupDetails;
      this.authSessionService.initializeUserSession(
        data?.result?.userDetail?.id,
        orgDetails,
        userGroup
      );

      // --- Step 4: Determine and navigate to the initial route ---
      let firstAccessibleUrl: any = this.commonService.getFirstAccessibleSubMenu(this.userRoles) || '/sales';
      if (Array.isArray(firstAccessibleUrl)) {
        firstAccessibleUrl = firstAccessibleUrl[0];
      }

      this.router.navigate([firstAccessibleUrl]).then(() => {
        const currentRoute = this.router.routerState.snapshot.root.children.find(route =>
          route.routeConfig?.path === firstAccessibleUrl.replace('/', '')
        );
        this.requiredRoles = currentRoute?.data?.['roles'];
        if (!this.requiredRoles || this.requiredRoles.some((role: any) => this.userRoles.includes(role))) {
          this.router.navigate([firstAccessibleUrl]);
        }
      });

    }, error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        this.errorMessage = 'Invalid username or password.';
      } else {
        this.errorMessage = 'An error occurred during login.';
      }
    });
  }
}
